import React from 'react'
import RightSide from '../components/common/rightSide';
import EditorGuidlines from '../components/other/editorGuidlines';



const EditorGuidlinesPage = () => {
    return (
        <>
            <div className='container-fluid mt-2'>
                <div className='row'>
                    {/* <div className='col-md-4'>
                        <RightSide />
                    </div> */}
                    <div className='col-md-12'>
                        <EditorGuidlines />
                    </div>

                </div>
            </div>
        </>
    )
}

export default EditorGuidlinesPage;